<div class="col-12 card-container">
  <ng-content></ng-content>
</div>
